import React from 'react';
import { Button } from './Button';
import { scrollToCompra } from '../utils/scroll';
import { Star } from 'lucide-react';
export function Hero() {
  return <section className="bg-brand-dark text-white pt-3 pb-4 px-4 relative overflow-hidden" data-id="element-100">
      {/* Top alert bar */}
      <div className="max-w-2xl mx-auto mb-4" data-id="element-101">
        <div className="bg-red-950/40 border border-red-900/40 rounded-full py-2 px-4 flex items-center justify-center gap-2" data-id="element-102">
          <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse shrink-0" data-id="element-103"></span>
          <p className="text-red-300 font-semibold text-[10px] md:text-xs uppercase tracking-tight text-center leading-tight" data-id="element-104">
            +2.500 docentes ya transformaron sus clases
          </p>
        </div>
      </div>

      <div className="max-w-2xl mx-auto relative z-10 flex flex-col items-center text-center" data-id="element-105">
        <h1 className="text-2xl md:text-4xl lg:text-5xl font-extrabold mb-3 leading-[1.1] text-white tracking-tight" data-id="element-106">
          Recuperá tu tiempo: Planificá todo tu año de{' '}
          <span className="text-brand-accent" data-id="element-107">Programación</span> en una sola
          tarde
        </h1>

        <p className="text-sm md:text-base mb-2 font-normal text-gray-400 max-w-xl mx-auto leading-relaxed" data-id="element-108">
          Planificaciones completas, secuencias didácticas y evaluaciones
          diseñadas para la realidad del aula técnica actual.
        </p>

        <p className="text-sm md:text-base mb-4 font-normal text-gray-400 max-w-xl mx-auto leading-relaxed" data-id="element-109">
          Un sistema integral basado en proyectos reales para docentes que
          buscan excelencia pedagógica sin sacrificar su vida personal.
        </p>

        <div className="w-full max-w-[340px] md:max-w-lg mx-auto my-2 cursor-pointer transform hover:scale-[1.02] transition-transform duration-200 relative" onClick={scrollToCompra} data-id="element-110">
          <div className="absolute inset-0 bg-brand-accent/15 blur-3xl rounded-full" data-id="element-111"></div>
          <img src="https://cdn.magicpatterns.com/uploads/fWRugVrZvWxSW6neH4RNPU/my-project-page-1_(3).png" alt="Kit Completo Programación PRO" className="w-full h-auto drop-shadow-2xl relative z-10" data-id="element-112" />
        </div>

        <div className="w-full max-w-md mx-auto mb-3 mt-2" data-id="element-113">
          <Button className="text-sm md:text-base py-4" data-id="element-114">
            🚀 → QUIERO MI KIT DE PROGRAMACIÓN AHORA
          </Button>
        </div>

        <p className="text-[10px] md:text-xs text-gray-400 font-medium mb-3" data-id="element-115">
          Acceso inmediato · Garantía de satisfacción · Actualizaciones 2026
        </p>

        {/* Stars + reviews */}
        <div className="flex items-center justify-center gap-2" data-id="element-116">
          <div className="flex text-brand-gold" data-id="element-117">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-118" />)}
          </div>
          <p className="text-white font-semibold text-xs md:text-sm" data-id="element-119">
            <span className="text-brand-gold" data-id="element-120">4,9/5</span>{' '}
            <span className="text-gray-400 font-normal" data-id="element-121">(+2.500 docentes)</span>
          </p>
        </div>
      </div>
    </section>;
}